/** Edge Function HTTP errors carry the useful server message in their response body. */
export async function adminFunctionError(error: unknown): Promise<Error> {
  if (error && typeof error === "object" && "context" in error && error.context instanceof Response) {
    try {
      const body = await error.context.clone().json();
      if (typeof body?.error === "string") return new Error(body.error);
    } catch {
      // Preserve the original error when the response isn't JSON.
    }
  }
  return error instanceof Error ? error : new Error("User management action failed");
}